import React, { memo, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import TooltipButton from '../../../../components/tooltip-button/TooltipButton';
import { ICONS } from '../../../../icons';
import Icon from '../../../../icons/Icon';
import CreateMessageModal from '../../../../scout-new/components/create-message-modal/CreateMessageModal';
import { createCustomMessages } from '../../../../redux/genie/genieActions';
import { GENIE_EVALUATE_TYPE } from '../../../../constants';

import scss from './CustomMessageButton.module.scss';

const CustomMessageButton = () => {
  const { t } = useTranslation('genie');
  const dispatch = useDispatch();

  const [isCreateModalOpen, setIsCrateModalOpen] = useState(false);
  const isEstimating = useSelector((state) => state.genie.evaluateActions[GENIE_EVALUATE_TYPE.GENERATED].pending);
  const generationUrl = useSelector((state) => state.genie.generationForm.url);
  const isGenerating = useSelector((state) => state.genie.isGenerating);

  const openCreateModal = () => {
    setIsCrateModalOpen(true);
  };

  const closeCreateModal = () => {
    setIsCrateModalOpen(false);
  };

  const handleCreateMessage = async ({ projectId, messages }) => {
    await dispatch(createCustomMessages({ projectId, messages }));
  };

  const tooltipMessage = useMemo(() => {
    if (isEstimating) {
      return t('messagesAreEstimatingNow');
    }

    if (!generationUrl) {
      return t('urlIsRequired');
    }

    if (isGenerating) {
      return t('messagesAreGeneratingNow');
    }

    return;
  }, [isEstimating, generationUrl, isGenerating, t]);

  return (
    <>
      <TooltipButton
        styleColor={BUTTON_STYLES.PRIMARY}
        onClick={openCreateModal}
        disabled={!!tooltipMessage}
        tooltip={tooltipMessage}
        className={scss.customMessageButton}
        maxWidth={180}>
        <Icon icon={ICONS.Edit} disableCommonColors />
        {t('customMessage')}
      </TooltipButton>

      <CreateMessageModal isOpen={isCreateModalOpen} onClose={closeCreateModal} onCreateMessage={handleCreateMessage} />
    </>
  );
};

export default memo(CustomMessageButton);
